import { SKU_SEPARATOR } from "../constants/code";
import { GenericObjectType } from "../types";

export const setPaperAdded = (state, val: { sku: string; active: boolean }) => {
  if (val) {
    state.paperAdded[val.sku] = val.active
  } 
  // else {
  //   const index = state.paperAdded.indexOf(id);
  //   if(index>-1){ state.paperAdded.splice(index, 1) }
  // }
}

/**
 * id -> planId for landings
 * is -> subscription id for rinnovi
 */
export const setChoosenShippingMethod = (state, id, val) => {
  state.choosenShippingMethod[id] = val;
  state.triggerChangeHelper = !state.triggerChangeHelper;
}

export const setSelectedShippingKey = (state, sku, skuValueIndex) => {
  state.selectedShippingKey[sku] = skuValueIndex;
  state.triggerChangeHelper = !state.triggerChangeHelper;
}

export const addModule = (state, val: GenericObjectType) => {
  state.choosenModules.set(val.sku, val);
  state.modulesKeys.push(`${val.position}${SKU_SEPARATOR}${val.sku}`)

}

export const removeModule = (state, val: GenericObjectType) => {
  state.choosenModules.delete(val.sku)
  const i = state.modulesKeys.indexOf(`${val.position}${SKU_SEPARATOR}${val.sku}`);
  state.modulesKeys.splice(i, 1);
}

export const toggleModule = (state, val: GenericObjectType) => {
  if(state.modulesKeys.length<state.acceptedQuantities || state.modulesKeys.includes(`${val.position}${SKU_SEPARATOR}${val.sku}`)){
    state.choosenModules.get(val.sku) ? removeModule(state, val) : addModule(state, val);
  }else{
    // remove last inserted modules
    const index = state.modulesKeys[state.modulesKeys.length - 1]
    const sku = index.split(SKU_SEPARATOR)[1];
    const moduleToRemove = state.choosenModules.get(sku as String);
    removeModule(state, moduleToRemove);
    // insert current clicked module
    addModule(state, val);
  }
}

export const emptyModules = (state) => {
  state.choosenModules = new Map();
  state.modulesKeys = [];
}

export const setAcceptedQuantities = (state, qty: number) => { state.acceptedQuantities = qty; }
export const setPaymentFrequencyChoosen = (state, getHighPaymentFrequency, val: string) => {
  state.paymentFrequencyChoosen = val;
  if (val != getHighPaymentFrequency()) {
    state.paperAdded = [];
    state.choosenShippingMethod = {};
  }
}